import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core'
import { Observable, Subject } from 'rxjs'
import { APP_ROUTES } from 'src/app/core/config/routes'
import { AuthService } from 'src/app/features/auth/services/auth.service'
import { LayoutService } from '../../services/layout.service'
import { takeUntil } from 'rxjs/operators'
import { SharedService } from '../../services/shared.service'
import { BLOB_URL, isMock } from 'src/app/core/config'
import { USER_TYPES } from 'src/app/core/enums'
import { DataService, NotifInfo } from '../../services/data.service'
import { Router } from '@angular/router'
import { Location } from '@angular/common'
import { ShepherdService } from 'angular-shepherd'
import { defaultStepOptions } from './config'

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('toggleIcon') toggleIcon: any
  @ViewChild('logout') logoutButton: ElementRef
  @ViewChild('login') loginButton: ElementRef

  isMenuToggled: boolean = true
  notifNumber: number

  componentDestroyed$ = new Subject<boolean>()

  BLOB_URL = BLOB_URL
  APP_ROUTES = APP_ROUTES
  USER_TYPES = USER_TYPES

  connectedUser: any
  isDemoMode: boolean = isMock
  todos$: Observable<NotifInfo>
  url: string

  constructor (
    private authService: AuthService,
    private layoutService: LayoutService,
    private sharedService: SharedService,
    private dataService: DataService,
    private router: Router,
    private location: Location,
    private shepherdService: ShepherdService
  ) {
    this.shepherdService.defaultStepOptions = defaultStepOptions
    this.shepherdService.modal = true
    this.router.events.subscribe(val => {
      if (location.path() != '') {
        this.url = location.path()
        console.log(this.url)
      } else {
        this.url = 'Home'
      }
    })
  }

  ngOnInit (): void {
    this.todos$ = this.dataService.todos$
    this.sharedService
      .getDemoStatus()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(status => {
        this.isDemoMode = status
      })
    this.getMenuToggleStatus()
    this.connectedUser = this.sharedService.getConnectedUser()
    console.log(this.connectedUser)

    // Initialize Shepherd with default options
    this.setupShepherdDefaultOptions()
  }

  ngAfterViewInit () {
    // Additional setup if needed
    this.startTour()
    this.setupTooltips() // Add this line
  }

  // Add this method to the component class
  setupTooltips () {
    // This ensures tooltips work with dynamic content
    setTimeout(() => {
      const tooltipElements = document.querySelectorAll('[data-tooltip]')

      tooltipElements.forEach(element => {
        // Remove any existing event listeners to avoid duplicates
        element.addEventListener('mouseenter', this.showTooltip)
        element.addEventListener('mouseleave', this.hideTooltip)
      })
    }, 0)
  }

  showTooltip (event: Event) {
    const target = event.target as HTMLElement
    const tooltip = target.querySelector('[data-tooltip]')
    if (tooltip) {
      tooltip.classList.add('tooltip-visible')
    }
  }

  hideTooltip (event: Event) {
    const target = event.target as HTMLElement
    const tooltip = target.querySelector('[data-tooltip]')
    if (tooltip) {
      tooltip.classList.remove('tooltip-visible')
    }
  }

  setupShepherdDefaultOptions () {
    // For angular-shepherd v11, we set default options directly on the service
    this.shepherdService.defaultStepOptions = {
      classes: 'shadow-md bg-purple-dark',
      scrollTo: true,
      cancelIcon: {
        enabled: true
      }
    }

    this.shepherdService.modal = true
    this.shepherdService.confirmCancel = false
  }

startTour() {
  const lastTourTimestamp = localStorage.getItem('navbarTourLastShown');
  const oneHour = 60 * 60 * 1000; // 1 hour in ms
  const now = Date.now();

  const hasBeenAnHour =
    !lastTourTimestamp || now - parseInt(lastTourTimestamp, 10) > oneHour;

  // Start the tour only if more than 1h has passed
  if (hasBeenAnHour) {
    setTimeout(() => {
      const tour = this.shepherdService;

      if (this.connectedUser) {
        this.setupLoggedInUserTour(tour);
      } else {
        this.setupGuestUserTour(tour);
      }

      tour.start();

      // persist in localStorage
      localStorage.setItem('isNavbarTourDone', 'true');
      localStorage.setItem('navbarTourLastShown', now.toString());
    }, 100);
  } else {
    console.log('🕒 Tour skipped (shown less than 1 hour ago)');
  }
}


  setupLoggedInUserTour (tour: any) {
    const steps = [
      {
        id: 'welcome',
        title: 'مرحباً بك في تطبيق خراج',
        text: 'هذا الدليل سيساعدك على التعرف على ميزات التطبيق',
        buttons: [
          {
            text: 'التالى',
            action: () => tour.next()
          }
        ]
      },
      {
        id: 'side-nav-toggle',
        title: 'القائمة الجانبية',
        text: 'هنا يمكنك فتح وإغلاق القائمة الجانبية التي تحتوي على خيارات التطبيق.',
        attachTo: {
          element: '#toggle-side-bar',
          on: 'bottom'
        },
        buttons: [
          {
            text: 'السابق',
            action: () => tour.back()
          },
          {
            text: 'التالى',
            action: () => tour.next()
          }
        ]
      },
      {
        id: 'user-profile',
        title: 'الملف الشخصي',
        text: 'هنا يمكنك الوصول إلى ملفك الشخصي، إعدادات الحساب، والخروج من التطبيق.',
        attachTo: {
          element: '#user-profile-dropdown',
          on: 'bottom'
        },
        buttons: [
          {
            text: 'السابق',
            action: () => tour.back()
          },
          {
            text: 'التالى',
            action: () => tour.next()
          }
        ]
      },
      {
        id: 'notifications',
        title: 'الإشعارات',
        text: 'هنا يمكنك عرض جميع الإشعارات والتنبيهات الخاصة بحسابك.',
        attachTo: {
          element: '#notifications-bell',
          on: 'bottom'
        },
        buttons: [
          {
            text: 'السابق',
            action: () => tour.back()
          },
          {
            text: 'التالى',
            action: () => tour.next()
          }
        ]
      }
    ]

    // Add action buttons based on user type
    if (
      this.connectedUser.type === USER_TYPES.BUYER_SELLER ||
      this.connectedUser.type === USER_TYPES.SELLER
    ) {
      steps.push({
        id: 'add-product',
        title: 'إضافة عرض',
        text: 'من هنا يمكنك إضافة عروض جديدة للمنتجات.',
        attachTo: {
          element: '#add-product-btn',
          on: 'bottom'
        },
        buttons: [
          {
            text: 'السابق',
            action: () => tour.back()
          },
          {
            text: 'التالى',
            action: () => tour.next()
          }
        ]
      })
    }

    if (
      this.connectedUser.type === USER_TYPES.TRANSPORTER_AGENT ||
      this.connectedUser.type === USER_TYPES.TRANSPORTER_COMPANY
    ) {
      steps.push({
        id: 'add-transport',
        title: 'إضافة وسيلة نقل',
        text: 'من هنا يمكنك إضافة وسائل نقل جديدة.',
        attachTo: {
          element: '#add-transport-btn',
          on: 'bottom'
        },
        buttons: [
          {
            text: 'السابق',
            action: () => tour.back()
          },
          {
            text: 'التالى',
            action: () => tour.next()
          }
        ]
      })
    }

    // Add wallet button step for eligible users
    if (
      this.connectedUser.type === USER_TYPES.BUYER_SELLER ||
      this.connectedUser.type === USER_TYPES.SELLER ||
      this.connectedUser.type === USER_TYPES.BUYER ||
      this.connectedUser.type === USER_TYPES.TRANSPORTER_AGENT ||
      this.connectedUser.type === USER_TYPES.TRANSPORTER_COMPANY
    ) {
      steps.push({
        id: 'wallet',
        title: 'شحن الرصيد',
        text: 'من هنا يمكنك شحن رصيد محفظتك.',
        attachTo: {
          element: '#wallet-btn',
          on: 'bottom'
        },
        buttons: [
          {
            text: 'السابق',
            action: () => tour.back()
          },
          {
            text: 'التالى',
            action: () => tour.next()
          }
        ]
      })
    }

    // Add final step
    steps.push({
      id: 'complete',
      title: 'اكتمل الدليل',
      text: 'لقد اكتمل الدليل التعريفي. يمكنك الآن استكشاف التطبيق بحرية.',
      buttons: [
        {
          text: 'السابق',
          action: () => tour.back()
        },
        {
          text: 'إنهاء',
          action: () => {
            tour.complete()
            localStorage.setItem('isNavbarTourDone', 'true')
          }
        }
      ]
    })

    // Add all steps to the tour using addSteps
    tour.addSteps(steps)
  }

  setupGuestUserTour (tour: any) {
    const steps = [
      {
        id: 'welcome',
        title: 'مرحباً بك في تطبيق خراج',
        text: 'هذا الدليل سيساعدك على التعرف على ميزات التطبيق',
        buttons: [
          {
            text: 'التالى',
            action: () => tour.next()
          }
        ]
      },
      {
        id: 'login',
        title: 'تسجيل الدخول',
        text: 'من هنا يمكنك تسجيل الدخول إلى حسابك للوصول إلى جميع الميزات.',
        attachTo: {
          element: '#login-btn',
          on: 'bottom'
        },
        buttons: [
          {
            text: 'السابق',
            action: () => tour.back()
          },
          {
            text: 'التالى',
            action: () => tour.next()
          }
        ]
      },
      {
        id: 'complete',
        title: 'اكتمل الدليل',
        text: 'سجل الدخول الآن للاستفادة من جميع ميزات التطبيق.',
        buttons: [
          {
            text: 'السابق',
            action: () => tour.back()
          },
          {
            text: 'إنهاء',
            action: () => {tour.complete()
              localStorage.setItem('isNavbarTourDone', 'true')
            }
          }
        ]
      }
    ]

    // Add all steps to the tour using addSteps
    tour.addSteps(steps)
  }

  openSideNav () {
    if (this.isMenuToggled) {
      document.getElementById('body').classList.add('g-sidenav-pinned')
      document.getElementById('body').classList.remove('g-sidenav-hidden')
      document.getElementById('backdrop').classList.remove('d-none')
    } else {
      document.getElementById('body').classList.remove('g-sidenav-pinned')
      document.getElementById('body').classList.add('g-sidenav-hidden')
      document.getElementById('backdrop').classList.add('d-none')
    }
    this.isMenuToggled = !this.isMenuToggled
    this.layoutService.toggleMenu()
  }

  logout () {
    this.authService.logout()
  }

  setNotifNumber (number: number) {
    this.notifNumber = number
  }

  getMenuToggleStatus () {
    this.layoutService
      .getMenuToggled()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((isToggled: boolean) => {
        this.isMenuToggled = isToggled
      })
  }

  toggleMenu () {
    this.layoutService.toggleMenu()
  }

  changeDemoMode () {
    this.sharedService.changeMockMode()
  }

  ngOnDestroy () {
    this.componentDestroyed$.complete()
  }
}
